/** Scroll the window to the top (used on navigation and repeat link clicks). */
export function scrollToTop(options?: { smooth?: boolean }) {
  const apply = () => {
    if (options?.smooth) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
  apply()
  if (!options?.smooth) {
    requestAnimationFrame(apply)
  }
}

/** Smooth scroll to the product reviews section on the detail page. */
export function scrollToProductReviews() {
  const el = document.getElementById('product-reviews')
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
